import React from 'react';
import CallToActionModal from '../../../../Common/CallToActionModal/CallToActionModal';
import CallToActionButton from '../../../../Common/CallToActionModal/CallToActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { HeapEvents, trackEvent } from '../../../../../utils/AnalyticsUtil';
import AuthorizeCRAActions from '../../../../../reducers/authorizeCRARedux';
import ApproveDraftsActions from '../../../../../reducers/approveDraftsRedux';
import SigningActions from '../../../../../reducers/signingRedux';
import DocumentsActions from '../../../../../reducers/documentsRedux';
import WorkflowActions from '../../../../../reducers/workflowRedux';
import WorkflowLinearSteps from './WorkflowLinearSteps';
import { CompletedStates } from '../../../../../utils/WorkflowTasks';
import FiledReturnSection from './FiledReturnSection';

const TaxYearWorkflow = (props) => {

    const dispatch = useDispatch();
    const selectedTaxYearTab = useSelector(state => state.layout.taxYearTab);
    const showContinueTaxInterview = !props.taxState.interview_state.complete;
    const pushNavigation = (path) => dispatch(push(path));
    const authorizeReset = () => dispatch(AuthorizeCRAActions.authorizeReset());
    const approveReset = () => dispatch(ApproveDraftsActions.approveReset());
    const signingStateReset = () => dispatch(SigningActions.signingStateReset());
    const signingStateDocumentsReset = () => dispatch(SigningActions.signingStateDocumentsReset());
    const setUploadStepToWorking = (taxYear) => dispatch(WorkflowActions.setUploadStepToWorking(taxYear));
    const setUploadStepCompleted = (taxYear, isComplete) => dispatch(DocumentsActions.setUploadStepCompleted(taxYear, isComplete));
    const setCaseDeletedStatus = (status, errorCode) => dispatch(WorkflowActions.setCaseDeletedStatus(status, errorCode));
    const signAdditionalForm = (taxYear, formName, isSpouse, completedRoute, spouseFirstName, primaryFirstName, originPath) => dispatch(SigningActions.signAdditionalForm(taxYear, formName, isSpouse, completedRoute, spouseFirstName, primaryFirstName, originPath));    
    const updateCaseState = () => dispatch(WorkflowActions.updateCaseState());
    const review_and_approve_paper_signature = useSelector(state => state.config?.appConfig?.reviewandapprovepapersignature)
    const pageNumber = props.taxState.interview_state.current_page;
    const isSelectedTaxYear = props.taxState.taxYear === selectedTaxYearTab;
    const showFiledReturn = props.taxState && CompletedStates.includes(props.taxState.ticketState)

    const handleWorkflowButton = (workflowAction, taxYear, contextData) => {
        switch (workflowAction || '') {
            case 'interview':
                pushNavigation('/dashboard/interview/' + taxYear + '/' + (contextData || '1'));
                break;
            case 'download':
                pushNavigation('/dashboard/completed_returns/' + taxYear);
                trackEvent(HeapEvents.DASHPG_DOWNLOAD_RETURN + '-' + taxYear);
                break;
            case 'confirm':
                pushNavigation('/dashboard/confirm_id');
                break;
            case 'authorize':
                authorizeReset();
                pushNavigation('/dashboard/authorize');
                break;
            case 'review-and-approve':
                var lastreviewedpage = props.caseState.taxYears.find(x => x.taxYear === taxYear).workflow_state.lastreviewedpage
                if (lastreviewedpage === 0)
                    lastreviewedpage = 1;
                approveReset();
                // Prevent stale completion/callback state from auto-switching review stage to spouse on first load.
                signingStateReset();
                signingStateDocumentsReset();

                review_and_approve_paper_signature
                    ? pushNavigation('/dashboard/reviewalt/' + taxYear + '/' + lastreviewedpage)
                    : pushNavigation('/dashboard/review/' + taxYear);
                break;
            case 'upload-docs-confirm':
                var state = contextData;
                if (state === 'no') {
                    setUploadStepToWorking(taxYear);
                    setUploadStepCompleted(taxYear, true);
                }
                break;
            case 'upload-docs':
                var comingFrom = contextData.comingFrom;
                pushNavigation(`/dashboard/uploader/${taxYear}/${comingFrom}?source=dashboard`);
                break;
            case 'payment':
                trackEvent(HeapEvents.PRIMARY_PAYMENT_LINK);
                window.open(contextData, "_self");
                break;
            case 'delete-return':
                setCaseDeletedStatus(null, null);
                setState({ deletingCase: false, taxYearToDelete: taxYear, showDeleteTaxYearModal: true });
                break;
            case 'additional_docs':
                signingStateDocumentsReset();
                signAdditionalForm(taxYear, contextData.document_type, contextData.is_spouse, '/dashboard', contextData.spouseFirstName, contextData.primaryFirstName, window.location.pathname);
                break;
            case 'signAuthRequestPrimary':
            case 'signAuthRequestSpouse':
                const isSpouse = workflowAction === 'signAuthRequestSpouse';
                const authRequest = props.taxState.authorization_requests?.find(req => 
                    req.id === contextData && req.taxpayerType === (isSpouse ? 'Spouse' : 'Primary')
                );
                if (authRequest) {
                    signingStateDocumentsReset();
                    signAdditionalForm(
                        taxYear, 
                        authRequest.documentName, 
                        isSpouse, 
                        '/dashboard',
                        props.caseState.spouseFirstName,
                        props.caseState.primaryFirstName,
                        window.location.pathname
                    );
                }
                break;
            default:
                break;
        }

        updateCaseState();
    }

    const onContinueTaxInterview = () => {
        trackEvent(HeapEvents.BUTTON_CONTINUE_TAX_INTERVIEW);
        handleWorkflowButton('interview', props.taxState.taxYear, pageNumber);
    }

    return isSelectedTaxYear && (
        <div> 
            { showContinueTaxInterview ?
                <CallToActionModal headerTitle='WorkflowPanel.ActionRequired'>
                    <CallToActionButton text='WorkflowPanel.ContinueTaxInterview' icon='file' buttonKey='interview' showChevron={true} onClick={onContinueTaxInterview} />
                </CallToActionModal> 
                :
                showFiledReturn ? 
                    <FiledReturnSection caseState={props.caseState} taxState={props.taxState} handleWorkflowButton={handleWorkflowButton} />
                    :
                    <WorkflowLinearSteps caseState={props.caseState} taxState={props.taxState} handleWorkflowButton={handleWorkflowButton} />
            }
        </div>
    );    
}

export default TaxYearWorkflow;